<template>
  <!-- dashboard-area start -->
  <div class="dashboard-area pt-30">
    <div class="container">
      <div class="col-12">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="pannel-wrapper white-bg mb-60">
              <div class="heading-border">
                
              </div>

              <div class="col-12">
            
              </div>

            
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- dashboard-area end -->
</template>

<script>
import serviceBuscaDescricao from "../services/ServiceBuscaDescricao";
import card from "../shared/cardResultado";

export default {
  components: {
    card
  },

  data() {
    return {
      dadosNCM: {},
      loading: true,
      descricaoNCM: this.$route.params.descricao,
    };
  },
  async created() {
    await serviceBuscaDescricao.getResultados(this.descricaoNCM).then(
      res => {
        if (res == "NCM não encontrada!") this.mensagemErro = res;
        this.dadosNCM = res;
        this.loading = false;
      },
      err => {
        console.error("nao foi possivel obter dados do servidor");
      }
    );
  },
  
};
</script>

<style scoped>
.w-50 {
  width: 50%;
}
.hr {
  border-bottom: 1px solid #eceff8;
  border-top: 0 none;
  margin: 10px 0;
  padding: 0;
}

.spinner-border {
  height: 100px;
  width: 100px;
  font-size: 30px;
}

.exibir-enter,
.exibir-leave-to {
  opacity: 0;
}

.exibir-enter-to,
.exibir-leave {
  opacity: 1;
}

.exibir-leave-active,
.exibir-enter-active {
  transition: all 0.5s;
}

.erro {
  font-size: 25px;
}
</style>